import { links } from "data";
import { ExternalLink } from "shared/components";
import { AccordionContainer } from "./accordion-container";
import styles from "./accordions.module.scss";

export const SERVICES_ACCORDION_KEY = "SERVICES_ACCORDION_KEY";

export const ServicesAccordion = () => {
  return (
    <AccordionContainer accordionKey={SERVICES_ACCORDION_KEY}>
      <div className="flex gap-sm">
        <div className="flex flex-column gap-xs">
          <ExternalLink
            href={links.COURIER_SERVICES}
            className={styles.subtitle}
          >
            Courier services
          </ExternalLink>
          <ExternalLink href={links.SAME_DAY_DELIVERY}>
            Same day courier
          </ExternalLink>
          <ExternalLink href={links.NEXT_DAY_DELIVERY}>
            Next day delivery
          </ExternalLink>
          <ExternalLink href={links.INTERNATIONAL_DELIVERY}>
            International delivery
          </ExternalLink>
          <ExternalLink href={links.MULTI_DROP_COURIER}>
            Multi-drop courier
          </ExternalLink>
          <ExternalLink href={links.IT_RELOCATION}>IT relocation</ExternalLink>
          <ExternalLink href={links.CONTACT_RUNS}>Contract runs</ExternalLink>
        </div>
        <div className="flex flex-column gap-xs">
          <ExternalLink
            href={links.LOGISTICS_SERVICES}
            className={styles.subtitle}
          >
            Logistics services
          </ExternalLink>
          <ExternalLink href={links.STORAGE_PICK_PACK}>
            Storage, pick & pack
          </ExternalLink>
          <ExternalLink href={links.FREIGHT_SERVICES}>
            Freight services
          </ExternalLink>
          <ExternalLink href={links.IN_NIGHT_DELIVERY}>
            In-night delivery
          </ExternalLink>
          <ExternalLink href={links.REFRIGERATED_VEHICLES}>
            Refrigerated vehicles
          </ExternalLink>
        </div>
        <div className="flex flex-column gap-xs">
          <ExternalLink
            href={links.HEALTHCARE_SERVICES}
            className={styles.subtitle}
          >
            Healthcare services
          </ExternalLink>
          <ExternalLink href={links.HOSPITAL_LOGISTICS}>
            Hospital Logistics
          </ExternalLink>
          <ExternalLink href={links.BLOOD_AND_ORGAN}>
            Blood and organ transportation
          </ExternalLink>
          <ExternalLink href={links.CLINICAL_TRIAL}>
            Clinical trial logistics
          </ExternalLink>
          <ExternalLink href={links.PATHOLOGY_SOLUTIONS}>
            Pathology solutions
          </ExternalLink>
          <ExternalLink href={links.PHARMACY_TO_HOME}>
            Pharmacy to home
          </ExternalLink>
          <ExternalLink href={links.WHOLESALER_LOGISTICS}>
            Wholesaler logistics
          </ExternalLink>
        </div>
        <div className={styles.separator} />
        <div className="flex flex-column gap-xs relative">
          <span className={styles.subtitle}>by industry...</span>
          <ExternalLink href={links.HEALTHCARE}>Healthcare</ExternalLink>
          <ExternalLink href={links.RETAIL}>Retail</ExternalLink>
          <ExternalLink href={links.PUBLIC_SECTOR}>Public sector</ExternalLink>
          <ExternalLink href={links.FACILITIES_MANAGEMENT}>
            Facilities management
          </ExternalLink>
        </div>
      </div>
    </AccordionContainer>
  );
};
